import { startOfDay, endOfDay } from "date-fns";

export const today = startOfDay(new Date()).toISOString();
export const endOfToday = endOfDay(new Date()).toISOString();
